/**
 * Centralized Hospital Information
 * This utility provides consistent hospital information across all receipts and print components.
 * Uses translation keys from Print.json for consistency.
 */

/**
 * Get hospital name from translation
 * @param {Function} t - Translation function from useTranslation hook
 * @returns {String} Hospital name
 */
export const getHospitalName = (t) => {
  return t("print.turkishClinic", {
    defaultValue: process.env.REACT_APP_HOSPITAL_NAME || "Mustashfa Omar Academic Hospital",
  });
};

/**
 * Get hospital address from translation
 * @param {Function} t - Translation function from useTranslation hook
 * @returns {String} Hospital address
 */
export const getHospitalAddress = (t) => {
  return t("print.address", {
    defaultValue:
      process.env.REACT_APP_HOSPITAL_ADDRESS ||
      "Mula Naqeeb Square, Kandahar, Afghanistan",
  });
};

/**
 * Get hospital phone from translation (if available) or environment variable
 * @param {Function} t - Translation function from useTranslation hook
 * @returns {String} Hospital phone number
 */
export const getHospitalPhone = (t) => {
  // Try translation first, then fallback to env or default
  const phoneLabel = t("print.phone", { defaultValue: "Phone" });
  const phoneNumber =
    process.env.REACT_APP_HOSPITAL_PHONE || "0780954954";
  return phoneNumber;
};

/**
 * Get complete hospital info object
 * @param {Function} t - Translation function from useTranslation hook
 * @returns {Object} Hospital information object
 */
export const getHospitalInfo = (t) => {
  return {
    name: getHospitalName(t),
    address: getHospitalAddress(t),
    phone: getHospitalPhone(t),
  };
};

/**
 * Get hospital info formatted for receipt header
 * @param {Function} t - Translation function from useTranslation hook
 * @returns {Object} Formatted hospital info for receipts
 */
export const getReceiptHeaderInfo = (t) => {
  const info = getHospitalInfo(t);
  return {
    hospitalName: info.name,
    hospitalAddress: info.address,
    hospitalPhone: info.phone,
    phoneLabel: t("print.phone", { defaultValue: "Phone" }),
  };
};

